import { AfterContentInit, QueryList, Renderer2 } from '@angular/core';
import { FuseWidgetToggleDirective } from './widget-toggle.directive';
var FuseWidgetComponent = /** @class */ (function () {
    function FuseWidgetComponent(renderer) {
        this.renderer = renderer;
        this.flipped = false;
    }
    FuseWidgetComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.toggleButtons.forEach(function (flipButton) {
                _this.renderer.listen(flipButton.elementRef.nativeElement, 'click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    _this.toggle();
                });
            });
        });
    };
    FuseWidgetComponent.prototype.toggle = function () {
        this.flipped = !this.flipped;
    };
    return FuseWidgetComponent;
}());
export { FuseWidgetComponent };
